import React, { useState } from 'react';
import { Modal, Button, Form, Image, Stack } from 'react-bootstrap';
import { CameraFill, Upload } from 'react-bootstrap-icons';

/**
 * MessageMediaModal
 *
 * Props
 * ────────────────────────────────────────────────────
 * @param {boolean} show
 * @param {function} onHide
 * @param {function} onSave – ({ text, files: File[] })
 */
const MessageMediaModal = ({ show, onHide, onSave }) => {
  const [text, setText] = useState('');
  const [files, setFiles] = useState([]);

  const handleFiles = (list) => {
    const arr = Array.from(list);
    setFiles((prev) => [...prev, ...arr].slice(0, 5)); // max 5
  };

  const handleCapture = (e) => handleFiles(e.target.files);

  const removeFile = (idx) =>
    setFiles((prev) => prev.filter((_, i) => i !== idx));

  const handleSave = () => {
    onSave?.({ text, files });
    onHide();
    setText('');
    setFiles([]);
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Message &amp; Photos</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Message to recipients:</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Enter details for dispatch / staff…"
          />
        </Form.Group>

        <Form.Group>
          <Stack direction="horizontal" gap={2} className="mb-2">
            <Form.Label className="mb-0">
              <Button as="span" variant="outline-secondary" size="sm">
                <Upload className="me-1" /> Choose Photos
              </Button>
              <Form.Control
                type="file"
                accept="image/*"
                multiple
                hidden
                onChange={(e) => handleFiles(e.target.files)}
              />
            </Form.Label>

            <Form.Label className="mb-0">
              <Button as="span" variant="outline-secondary" size="sm">
                <CameraFill className="me-1" /> Take Photo
              </Button>
              <Form.Control
                type="file"
                accept="image/*"
                capture="environment"
                hidden
                onChange={handleCapture}
              />
            </Form.Label>
          </Stack>

          {files.length > 0 && (
            <Stack direction="horizontal" gap={2} className="flex-wrap">
              {files.map((f, idx) => (
                <div key={idx} style={{ position: 'relative' }}>
                  <Image
                    src={URL.createObjectURL(f)}
                    thumbnail
                    style={{ width: 80, height: 80, objectFit: 'cover' }}
                  />
                  <Button
                    size="sm"
                    variant="danger"
                    style={{
                      position: 'absolute',
                      top: -6,
                      right: -6,
                      borderRadius: '50%',
                      padding: '0 4px',
                    }}
                    onClick={() => removeFile(idx)}
                  >
                    ×
                  </Button>
                </div>
              ))}
            </Stack>
          )}
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={!text && files.length === 0}
          onClick={handleSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MessageMediaModal;
